import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

interface Props {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export function HtmlSignatureEditor({ value, onChange, label = 'חתימת HTML' }: Props) {
  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <Label>{label}</Label>
        <Textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={8}
          placeholder="<p>בברכה,<br>שם הנציג</p>"
          className="font-mono text-xs ltr"
          dir="ltr"
        />
      </div>

      <div className="space-y-1">
        <Label>תצוגה מקדימה</Label>
        <div
          className="min-h-24 rounded-md border bg-white p-3 text-sm"
          dir="rtl"
          dangerouslySetInnerHTML={{ __html: value || '<span style="color:#999">אין חתימה</span>' }}
        />
      </div>
    </div>
  );
}
